import { Component } from 'preact'
import Icon from '../assets/index'

export default class extends Component {
  toggleMenuItem (event, { name }) {
    if (event) event.preventDefault()
    this.setState({ [name]: !this.state[name] })
  }

  render ({ sidebar, customFilters }, state) {
    return <ul class='nav nav-sidebar'>
      { sidebar.map((item) => {
        const isActive = item.links.some(isActiveLink) || (item.name === 'moderation' && customFilters && customFilters.some(isActiveLink))
        return <li className='li-hover' key={item.name}>
          <a className={`${isActive ? 'active' : ''} ${this.state[item.name] || isActive ? 'collapsed' : ''} nav-list-title ${item.name}`}
            href='#'
            title={item.label}
            onClick={(event) => this.toggleMenuItem(event, item)}>
            <Icon icon={item.iconName} height='16' width='16' />
            <span>{item.label}</span>
          </a>
          <ul className={'nav-list-dropdown' + (item.isActive ? ' active' : '')}>
            {item.links.map(renderLink(false))}
            {item.name === 'moderation' && customFilters ? customFilters.map(renderLink(true)) : null}
          </ul>
        </li>
      })
      }
    </ul>
  }
}

const isActiveLink = (link) => {
  const index = link.route.indexOf('#')

  if (index > 0) {
    return window.location.pathname + window.location.search + window.location.hash === link.route
  }

  return window.location.pathname + window.location.search === link.route
}

const renderLink = (isCustomFilter) => {
  return (link) => {
    const isActive = isActiveLink(link)

    return <li
      className={'navigation-menu__item navigation-menu__item--' + link.label.toLowerCase().replace(/ /g, '_') + (isCustomFilter ? ' custom qa-custom' : '')}>
      <a href={link.route} className={`collapsed ${isActive ? 'active' : ''}`}>{link.label}</a>
    </li>
  }
}
